// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import PhotoSession from "./photo-session.js"

const modelClassData = {
  "attributes": {
    "group_type": {
      "column": {
        "default": "school_class",
        "name": "group_type",
        "null": false,
        "type": "string"
      },
      "name": "group_type",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "kmd_serial_number": {
      "column": {
        "default": null,
        "name": "kmd_serial_number",
        "null": true,
        "type": "string"
      },
      "name": "kmd_serial_number",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_contacts_count": {
      "column": {
        "default": 0,
        "name": "photo_session_group_contacts_count",
        "null": false,
        "type": "integer"
      },
      "name": "photo_session_group_contacts_count",
      "selected_by_default": null,
      "translated": null
    },
    "photos_count": {
      "column": {
        "default": 0,
        "name": "photos_count",
        "null": false,
        "type": "integer"
      },
      "name": "photos_count",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "translated_group_type": {
      "column": null,
      "name": "translated_group_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "PhotoSessionGroup",
  "collectionKey": "photo_session_groups",
  "collectionName": "photo_session_groups",
  "i18nKey": "photo_session_group",
  "camelizedLower": "photoSessionGroup",
  "name": "PhotoSessionGroup",
  "nameDasherized": "photo-session-group",
  "pluralName": "photo_session_groups",
  "ransackable_associations": [
    {
      "className": "ContactPhotoSessionCurrent",
      "collectionName": "contact_photo_session_currents",
      "foreignKey": "photo_session_group_id",
      "name": "contact_photo_session_currents",
      "macro": "has_many",
      "resource_name": "ContactPhotoSessionCurrent",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "photo_session_group_contacts"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "belongs_to",
      "resource_name": "PhotoSession",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group_contacts",
      "macro": "has_many",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_session_group_id",
      "name": "photos",
      "macro": "has_many",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_session_group_id",
      "name": "preferred_photo",
      "macro": "has_one",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "group_type",
      "column": {
        "default": "school_class",
        "name": "group_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "kmd_serial_number",
      "column": {
        "default": null,
        "name": "kmd_serial_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "photo_session_group_contacts_count",
      "column": {
        "default": 0,
        "name": "photo_session_group_contacts_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "photo_session_id",
      "column": {
        "default": null,
        "name": "photo_session_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photos_count",
      "column": {
        "default": 0,
        "name": "photos_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "belongs_to",
      "resource_name": "PhotoSession",
      "through": null
    }
  ],
  "paramKey": "photo_session_group",
  "primaryKey": "id"
}

/** Frontend model for PhotoSessionGroup. */
export default class PhotoSessionGroup extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  groupType() {
    return this.readAttributeUnderscore("group_type")
  }

  /** @returns {boolean} */
  hasGroupType() {
    const value = this.groupType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  kmdSerialNumber() {
    return this.readAttributeUnderscore("kmd_serial_number")
  }

  /** @returns {boolean} */
  hasKmdSerialNumber() {
    const value = this.kmdSerialNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoSessionGroupContactsCount() {
    return this.readAttributeUnderscore("photo_session_group_contacts_count")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupContactsCount() {
    const value = this.photoSessionGroupContactsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photosCount() {
    return this.readAttributeUnderscore("photos_count")
  }

  /** @returns {boolean} */
  hasPhotosCount() {
    const value = this.photosCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedGroupType() {
    return this.readAttributeUnderscore("translated_group_type")
  }

  /** @returns {boolean} */
  hasTranslatedGroupType() {
    const value = this.translatedGroupType()

    return this._isPresent(value)
  }

  /** @returns {import("./photo-session.js").default | null} */
  photoSession() {
    return this._readBelongsToReflection({modelClass: PhotoSession, reflectionName: "photo_session"})
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  loadPhotoSession() {
    if (!("photoSessionId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionId")

    const id = this.photoSessionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session",
        model: this,
        modelClass: PhotoSession
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  ensurePhotoSessionLoaded() {
    return this.ensureAssociationLoaded("photo_session")
  }
}
